import { render, staticRenderFns } from "./accomodations.vue?vue&type=template&id=01ef2dbe&scoped=true&"
import script from "./accomodations.vue?vue&type=script&lang=js&"
export * from "./accomodations.vue?vue&type=script&lang=js&"
import style0 from "./accomodations.vue?vue&type=style&index=0&id=01ef2dbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ef2dbe",
  null
  
)

export default component.exports